import {compose, map, filter, assocPath, converge, always, identity, prop, isNotNil} from "ramda";

const filterAndStringify = compose(
  map(paramValue => `${paramValue}`),
  filter(isNotNil)
);

const stringifyParams = converge(assocPath, [
  always(['params']),
  compose(filterAndStringify, prop('params')),
  identity
])

export default stringifyParams;
